<template>
  <v-dialog
    max-width="500"
    :value="noAlcoholOrTobaccoDeliveryDialog"
    @click:outside="goBackToCart"
  >
    <v-card class="py-10 px-7">
      <!--
      <CloseDialogButton :close="closeNoAlcoholOrTobaccoDeliveryDialog" />
      -->
      <div class="align-center d-flex flex-column">
        <NoDeliveryIcon />
        <div class="font-size-lg mb-12 text-center">
          Delivery of
          <span class="primary-color">{{ textContent }}</span>
          products is not permitted in this area. To proceed with your delivery
          order, please remove these items.
        </div>
        <v-btn
          color="primary"
          height="48"
          width="180"
          rounded
          @click.stop="goBackToCart"
        >
          <div class="font-size-md text-capitalize">Back to Cart</div>
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
// import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";
import NoDeliveryIcon from "@/elements/NoDeliveryIcon.vue";

export default {
  name: "NoAlcoholOrTobaccoDeliveryDialog",
  // components: { CloseDialogButton, NoDeliveryIcon },
  components: { NoDeliveryIcon },
  computed: {
    ...mapState({
      storeInfo: (state) => state.store.info,
    }),
    textContent() {
      const storeDeliversAlcohol = this.storeInfo.alcohol_delivery_allowed;
      const storeDeliversTobacco = this.storeInfo.tobacco_delivery_allowed;
      return (!storeDeliversAlcohol && !storeDeliversTobacco) ||
        this.interstateDeliveryIssue
        ? "Alcohol & Tobacco"
        : !storeDeliversAlcohol
        ? "Alcohol"
        : "Tobacco";
    },
  },
  methods: {
    goBackToCart() {
      this.closeNoAlcoholOrTobaccoDeliveryDialog();
      this.$vuetify.breakpoint.xsOnly
        ? this.$router.push({ name: "cart" })
        : this.routeToCart();
    },
    routeToCart() {
      this.$store.commit("cart/TOGGLE");
      this.$router.push("/");
    },
  },
  props: {
    closeNoAlcoholOrTobaccoDeliveryDialog: Function,
    interstateDeliveryIssue: Boolean,
    noAlcoholOrTobaccoDeliveryDialog: Boolean,
  },
};
</script>
